import { Article } from 'shared/components/Article';
import { useGuideAnalytics, useLazyArticleImage } from 'shared/hooks';
import type { TArticle } from 'shared/types/carousel';

interface IArticleContainerProps extends TArticle {
  categoryName?: string;
}

export const ArticleContainer: React.FC<IArticleContainerProps> = ({ image, title, url, minutes, categoryName }) => {
  const { src, isImageLoaded, containerRef, onImageLoad, onImageError } = useLazyArticleImage({ image });
  const { trackArticleClick } = useGuideAnalytics();

  return (
    <Article
      ref={containerRef}
      title={title}
      url={url}
      minutes={minutes}
      src={src}
      isImageLoaded={isImageLoaded}
      onImageLoad={onImageLoad}
      onImageError={onImageError}
      onClick={() => trackArticleClick(title, url, categoryName)}
    />
  );
};
